import { CURRENT_PREISMODELL } from '@/domain/vertraege/shared/hooks/preismodelle';

export enum VertragStatus {
  Aktiv = 'AKTIV',
  Beendet = 'BEENDET',
  Gekuendigt = 'GEKUENDIGT',
  ZuKlaeren = 'ZU_KLAEREN',
}

export enum VertragZahlungsmethode {
  SEPA = 'SEPA',
  UEBERWEISUNG = 'UEBERWEISUNG',
  UNBEKANNT = 'UNBEKANNT',
}

export enum VertragTarif {
  MITARBEITER = 'MITARBEITER',
  STANDORTE = 'STANDORTE',
  UNBEKANNT = 'UNBEKANNT',
}

export class SummeNetto {
  constructor({ waehrung, wert }: { waehrung: string; wert: number }) {
    this.waehrung = waehrung;
    this.wert = wert;
  }

  readonly waehrung: string;
  readonly wert: number;
}

export class Vertrag {
  constructor({
    id,
    kundennummer,
    unternehmensname,
    aktiveAnzahl,
    vereinbarteAnzahl,
    vertragTarif,
    vertragIntervall,
    faelligkeitsdatum,
    summeNetto,
    vertragZahlungsmethode,
    preisModell,
    status,
  }: {
    id: string;
    kundennummer: number;
    unternehmensname: string;
    aktiveAnzahl: number;
    vereinbarteAnzahl: number;
    vertragTarif: string;
    vertragIntervall: string;
    faelligkeitsdatum: string | undefined;
    summeNetto: SummeNetto;
    vertragZahlungsmethode: VertragZahlungsmethode;
    preisModell: string;
    status: VertragStatus;
  }) {
    this.id = id;
    this.kundennummer = kundennummer;
    this.unternehmensname = unternehmensname;
    this.faelligkeitsdatum = faelligkeitsdatum;
    this.aktiveAnzahl = aktiveAnzahl;
    this.vereinbarteAnzahl = vereinbarteAnzahl;
    this.vertragTarif = vertragTarif;
    this.vertragIntervall = vertragIntervall;
    this.summeNetto = summeNetto;
    this.vertragZahlungsmethode = vertragZahlungsmethode;
    this.preisModell = preisModell;
    this.status = status;
  }

  readonly id: string;
  readonly kundennummer: number;
  readonly unternehmensname: string;
  readonly faelligkeitsdatum?: string;
  readonly aktiveAnzahl: number;
  readonly vereinbarteAnzahl: number;
  readonly status: VertragStatus;
  readonly vertragTarif: string;
  readonly vertragIntervall: string;
  readonly vertragZahlungsmethode: VertragZahlungsmethode;
  readonly summeNetto: SummeNetto;
  readonly preisModell: string;

  hasAktuellesVertragsmodell(): boolean {
    return this.preisModell === CURRENT_PREISMODELL;
  }
}
